import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NeededActionsInfo, NeededActionsVinRequest, SVDSInfo, VehicleModel } from 'src/app/shared/models/case-creation/vehicle.model';

import { CaseType } from '../../shared/enums/case-type.enum';
import { DealershipCaseStatus } from '../../shared/enums/dealearship-case-status.enum';
import { FleetSegmentCalculationStatus } from '../../shared/enums/fleet-segment-calculation-status.enum';
import { CheckVin } from '../../shared/models/check-vin.model';
import { VehicleInformation } from '../../shared/models/vehicle-information.model';
import { DealerInformation } from 'src/app/shared/models/dealer-information.model';

@Injectable()
export class VehicleService {
  private readonly httpClient = inject(HttpClient);
  private readonly vehicleApiUrl = '/api/vehicle';
  private readonly dealershipApiUrl = '/api/dealership/vehicle';

  getVehicleInfo(vins: string[], dealerVPNr: string, bpId: string): Observable<CheckVin[]> {
    const params = new HttpParams().set('dealer-vpnr', dealerVPNr).set('bp-id', bpId);
    return this.httpClient.post<CheckVin[]>(`${this.dealershipApiUrl}/check-manual-vin`, vins, {
      params,
    });
  }

  getGridCases(bpId: string, caseStatus: DealershipCaseStatus = DealershipCaseStatus.OPEN): Observable<VehicleModel[]> {
    return this.httpClient.get<VehicleModel[]>(`/api/dealership/cases?bp-id=${bpId}&case-status=${caseStatus}`);
  }

  getDealerFleet(bpId: string): Observable<SVDSInfo[]> {
    return this.httpClient.get<SVDSInfo[]>(`/api/dealership/fleet/${bpId}`);
  }

  createDealerFleet(bpId: string): Observable<void> {
    return this.httpClient.post<void>(`/api/dealership/fleet/${bpId}`, {});
  }

  getFleetStatus(bpId: string): Observable<FleetSegmentCalculationStatus[]> {
    return this.httpClient.get<FleetSegmentCalculationStatus[]>(`/api/dealership/fleet/${bpId}/status`);
  }

  getVehicleMasterData(vin: string): Observable<VehicleInformation> {
    return this.httpClient.get<VehicleInformation>(`${this.vehicleApiUrl}/information/${vin}`);
  }

  getMultipleNeededActions(
    vinRequests: NeededActionsVinRequest[],
    caseType: CaseType,
    dealer: DealerInformation,
    marketCode: string,
    language: string
  ): Observable<NeededActionsInfo[]> {
    const params = new HttpParams()
      .set('buno', dealer.buno)
      .set('invalidate-cache', true)
      .set('dealer', dealer.bpId)
      .set('case-type', caseType)
      .set('market-code', marketCode)
      .set('local-user-time-offset', new Date().getTimezoneOffset())
      .set('language', language);

    return this.httpClient.post<NeededActionsInfo[]>(`${this.vehicleApiUrl}/needed-actions`, vinRequests, { params });
  }
}
